import {Component, Input, OnInit} from '@angular/core';
import {Equipe} from "../../models/equipe";
import {EquipesService} from "../../services/equipes.service";

@Component({
  selector: 'app-show-equipe',
  templateUrl: './show-equipe.component.html',
  styleUrls: ['./show-equipe.component.scss']
})
export class ShowEquipeComponent implements OnInit {

  @Input() ids: number[];

  equipes: Equipe[];


  constructor(private equipeService: EquipesService) { }

  ngOnInit(): void {
      if (this.ids && this.ids.length>0) {
        this.equipeService.findByIds(this.ids)
            .subscribe(res => {
              if(res && res.length > 0) {
                this.equipes = res;
              }
            }, err => {
              console.log(err);
            });
      }
  }

}
